import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import store from 'store';

import Text from 'components/Text';
import TabNavigation from 'components/TabNavigation';
import TicketsTable from 'components/Table/Tickets';
import { modelTicket } from 'components/Table/Tickets/models';
import { ITableModel } from 'components/Table/interface';
import { Button } from 'components/Button';
import { eventName, protocolosAction } from 'components/ApplicationInsights/eventNames';

import { TicketTabsEnum } from 'models/Ticket';
import { useTicketsContext } from 'contexts/Tickets';

const Protocols: React.FC = () => {

  const user = useSelector((state: RootState) => state.user);
  const pageSize = 10;

  const [ticketsFilter, setTicketsFilter] = useState({
    statusType: { ne: 'DONE' },
  });

  const { setRefreshTable, refreshTable } = useTicketsContext();

  const editButtonLabel: ITableModel = {
    label: 'Protocolo',
    key: 'protocolNumber',
    size: 130,
    maxSize: 130,
    Component: (data: any) => (
      <Button
        trackName={protocolosAction.VISUALIZARPROTOCOLO}
        trackAction={eventName.PROTOCOLOS}
        className="px-0"
        onClick={() =>
          store.dispatch({
            type: 'OPEN_CARD',
            data: {
              id: data.cardId,
              protocolNumber: data.protocolNumber,
              responsibleGroup: data.responsibleGroup,
              ticketId: data.id,
              ticketDevolution: data.ticketDevolution || null,
              ticketCorrectionLetter: data.ticketCorrectionLetter || null,
              ticketReason: data.ticketReason,
              state: { setRefreshTable },
            },
          })
        }
        width="auto"
      >
        <Text className="color-blue-gray" size={12}>
          {data.protocolNumber}
        </Text>
      </Button>
    ),
  };

  const ticketModelEdit: Array<ITableModel> = [editButtonLabel, ...modelTicket];

  return (
    <>
      <Text size={24} className="color-primary font-bold">
        Protocolos
      </Text>
      <TabNavigation
        trackingKey="Abas Protocolos"
        trackingEvent={eventName.PROTOCOLOS}
        className="mt-3"
        setTabFilter={(filter) => setTicketsFilter(filter)}
        tabLabels={[
          { label: 'Abertos', filter: { statusType: { ne: 'DONE' } }, trackingName: protocolosAction.ABA_DASHBOARD_PROTOCOLOSABERTOS },
          { label: 'Fechados', filter: { statusType: { eq: 'DONE' } }, trackingName: protocolosAction.ABA_DASHBOARD_PROTOCOLOSFECHADOS },
        ]}
        pages={[
          <TicketsTable
            trackingKey="Protocolos Abertos"
            pageSize={pageSize}
            model={ticketModelEdit}
            tabFilter={ticketsFilter}
            showFilter
            initialOrder="createdDate desc"
            refreshTable={refreshTable}
            /*showExportButton={user?.userType === 'employee'}*/
            showExportButton={false}
            isPageTickets
            statusTypes={[0, 1]}
            currentTabId={TicketTabsEnum.PROTOCOLO_ABERTO}

          />,
          <TicketsTable
            trackingKey="Protocolos Concluidos"
            pageSize={pageSize}
            model={ticketModelEdit}
            tabFilter={ticketsFilter}
            showFilter
            refreshTable={refreshTable}
            /*showExportButton={user?.userType === 'employee'}*/
            showExportButton={false}
            isPageTickets
            statusTypes={[2]}
            currentTabId={TicketTabsEnum.PROTOCOLO_FECHADO}
          />,
        ]}
      />
    </>
  );
};

export default Protocols;
